import {zip, of} from 'rxjs';
import {flatMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import {fetchClosingDaysObservable} from 'web-app/react/closing-days/epics';

import * as Actions from './actions';

const fetch = action$ =>
    action$.ofType(Actions.fetch.type).mergeMap(({payload}) =>
        zip(fetchClosingDaysObservable(payload.institutionId)).pipe(
            flatMap(actions => [Actions.fetchSuccess.action(), ...actions]),
            catchError(e => of(Actions.fetchFailed.action(e))),
        ),
    );

export default combineEpics(fetch);
